import { render } from "./UserRegisterInfoView.vue?vue&type=template&id=370923a1&ts=true"
import script from "./UserRegisterInfoView.vue?vue&type=script&lang=ts"
export * from "./UserRegisterInfoView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/kosugi/Dev/IdeaProjects/v4/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__